import React, { useState } from "react";
import { StyleSheet, View } from "react-native";

import { buttonStyle } from "../common/ActionsMenuButton/utils";
import ActionButton from "../common/ActionsMenuButton/ActionButton";
import AddGoalIcon from "../common/ActionsMenuButton/icons/AddGoalIcon";
import AllGemsIcon from "../common/ActionsMenuButton/icons/AllGemsIcon";
//import TimeMachineIcon from "../common/ActionsMenuButton/icons/TimeMachineIcon";
import { getContactMailUrl, openURL } from "../../../helpers/utils";
import AppTheme from "../AppTheme";
import InviteIcon from "../common/ActionsMenuButton/icons/InviteIcon";

export default function ResolutionFabButton({
  addNewGoal,
  viewAllGems,
  aboutThisScreen,
  //selectedDate,
  //showDateSelector,
  style = {},
  mariOptions = {},
}) {
  const [actionButton, setActionButton] = useState(null);

  const actions = [
    <ActionButton.Item
      key={1}
      hideShadow
      buttonColor="#FFF"
      title="Help"
      onPress={() => {
        openURL(getContactMailUrl());
      }}
    >
      <InviteIcon style={styles.actionButtonIcon} />
    </ActionButton.Item>,

    <ActionButton.Item
      key={2}
      underline
      hideShadow
      buttonColor="#FFF"
      title="About this screen"
      onPress={aboutThisScreen}
    >
      <InviteIcon style={styles.actionButtonIcon} />
    </ActionButton.Item>,

    {
      /* <ActionButton.Item
          key={3}
          hideShadow
          buttonColor="#FFF"
          title={selectedDate ? "Return to present" : "Time Machine" }
          onPress={showDateSelector}
        >
          <TimeMachineIcon style={styles.actionButtonIcon} />
        </ActionButton.Item> */
    },

    <ActionButton.Item
      key={4}
      hideShadow
      buttonColor="#FFF"
      title="All Gems"
      onPress={viewAllGems}
    >
      <AllGemsIcon style={styles.actionButtonIcon} />
    </ActionButton.Item>,

    <ActionButton.Item
      key={5}
      isSelected={mariOptions.showTutorials}
      hideShadow
      buttonColor="#FFF"
      title="New Goal"
      onPress={addNewGoal}
    >
      <AddGoalIcon style={styles.actionButtonIcon} />
    </ActionButton.Item>,
  ];

  return (
    <View
      style={[buttonStyle, style]}
      onLayout={(event) => {
        if (actionButton != null)
          actionButton.setParentLayout(event.nativeEvent.layout);
      }}
    >
      <ActionButton
        mariOptions={mariOptions}
        ref={(r) => setActionButton(r)}
        buttonColor={AppTheme.DEFAULT_COLOR}
        zIndex={999}
        source={"ResolutionFabButton"}
        buttonTextStyle={styles.mainButton}
      >
        {actions}
      </ActionButton>
    </View>
  );
}

const styles = StyleSheet.create({
  mainButton: {
    fontSize: 44,
    height: 58,
    marginTop: -5,
    fontWeight: "200",
  },
  actionButtonIcon: {
    marginTop: 5,
    width: 44,
    height: 44,
  },
});
